import AbstractAccordion from '@/modules/common/common/models/APP/accordions/AbstractAccordion'
import Insurance from '@/modules/common/common/models/APP/Insurance'

export default class TravelInsurance extends Insurance {
  copayType: string | null
  copayText: string | null
  contractType?: string | null
  deficiencies: AbstractAccordion<any>
  coverages: AbstractAccordion<any>
  optionalCoverages: AbstractAccordion<any>

  constructor(data: Partial<TravelInsurance>) {
    super(data)

    this.copayType = data.copayType ?? null
    this.copayText = data.copayText ?? null
    this.contractType = data.contractType ?? null
    this.highlights = data.highlights ?? []
    this.deficiencies = data.deficiencies!
    this.coverages = data.coverages!
    this.optionalCoverages = data.optionalCoverages!
    this.deficiencies = data.deficiencies!
    this.sections = data.sections ?? []
  }

  getMandatoryFeatures() {
    return [this.coverages, this.optionalCoverages, this.deficiencies].filter((v) => !!v)
  }
}
